/**
 * Whether a row in a day bucket has anything rendered after it.
 *
 * Games and events are two separate groups inside one day, and each row type
 * spaces itself with its own `margin-bottom`, applied only when something
 * follows. Computed per group, the LAST game reports "nothing after me" and
 * drops its margin — even when event cards follow it, leaving the two flush
 * against each other.
 *
 * So the last game's answer depends on the OTHER group: it has a row after it
 * when any event does.
 */
export const hasRowAfter = ({
  index,
  count,
  hasFollowingGroup = false,
}: {
  /** This row's index within its own group. */
  index: number
  /** How many rows the group holds. */
  count: number
  /** True when another group renders after this one. */
  hasFollowingGroup?: boolean
}): boolean => index !== count - 1 || hasFollowingGroup
